import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { isEmpty } from 'lodash';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(0),
      //   width: '28ch',
      },
    },
  }));

export default function InputComponent(props) {
    const classes = useStyles();
    const [IsConnectedWith, setContactPerson] = React.useState(props.IsConnectedWith);

    React.useEffect(()=>{
      setContactPerson(props.IsConnectedWith)
    },[props.IsConnectedWith])
  React.useEffect(()=>{
    if(!isEmpty(props.ListOfAVPro)){
     let hasAvtalWithSameType=isEmpty(props.ListOfAVPro.filter(item=>{return item.Type === props.OrderType}))?0:
      props.ListOfAVPro.filter(item=>{return item.Type === props.OrderType})[0].id
      props.handleChange({target:{
        value:parseInt(hasAvtalWithSameType) === 0?0:1,
        name:"IsConnectedWith"
      }})     
    }
  },[props.ListOfAVPro])
  //props.OrderType,
    return (
        <form className={classes.root} noValidate autoComplete="off">
      <div>
        <TextField
          variant="outlined"
          fullWidth
          label={<IntlMessages id="input.Connect.Contract"/>}
          size="small"
          name="IsConnectedWith"
          select
          value={IsConnectedWith}
          SelectProps={{
            native: true,
          }}
          disabled={props.disabled}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={props.handleChange}
        >
          {props.currencies.map((option) => (
             <option key={option.value} value={option.value}>
             {option.label}
             </option>
          ))}
        </TextField>
      </div>
    </form>
    );
}